"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var EmailAddressInput_vue_1 = __importDefault(require("./form/EmailAddressInput.vue"));
var PasswordInput_vue_1 = __importDefault(require("./form/PasswordInput.vue"));
var Window_vue_1 = __importDefault(require("./Window.vue"));
var VButton_vue_1 = __importDefault(require("./scraps/VButton.vue"));
var store_1 = require("../store");
exports.default = vue_1.default.extend({
    name: "the-login",
    components: { EmailAddressInput: EmailAddressInput_vue_1.default, PasswordInput: PasswordInput_vue_1.default, Window: Window_vue_1.default, VButton: VButton_vue_1.default },
    data: function () {
        return {
            email: "",
            password: ""
        };
    },
    methods: {
        onLoginButtonClick: function () {
            var self = this;
            this.$store.dispatch(store_1.Action.authorize, {
                vue: self,
                email: this.email,
                password: this.password
            });
        },
        onKeyDown: function (keyCode) {
            if (keyCode === 13) {
                this.onLoginButtonClick();
            }
        }
    }
});
